import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { media } from "sprout-ui-theme";
import { Text, Flex } from "sprout-ui-primitives";
import styled, { css } from "styled-components";
const DialogContextualActionBarWrapper = styled(Flex)`
  ${({ $hideContextualActionBar  })=>$hideContextualActionBar === "desktop" && css`
      ${media.up("small")} {
        display: none;
      }
    `}
`;
const DialogContextualActionBar = (props)=>{
    const { contextualTitle , leftAction , rightAction , hideContextualActionBar  } = props;
    return /*#__PURE__*/ _jsxs(DialogContextualActionBarWrapper, {
        $hideContextualActionBar: hideContextualActionBar,
        borderTopLeftRadius: "inherit",
        borderTopRightRadius: "inherit",
        alignItems: "center",
        height: "56px",
        flex: "none",
        children: [
            /*#__PURE__*/ _jsx(Flex, {
                flex: "1",
                alignItems: "flex-start",
                children: leftAction
            }),
            /*#__PURE__*/ _jsx(Text, {
                as: "span",
                fontWeight: "bold",
                fontSize: 3,
                children: contextualTitle
            }),
            /*#__PURE__*/ _jsx(Flex, {
                flex: "1",
                alignItems: "flex-end",
                children: rightAction
            })
        ]
    });
};
export default DialogContextualActionBar;
